import { render, staticRenderFns } from "./EndpointConfigModal.vue?vue&type=template&id=a1c81b8e&scoped=true"
import script from "./EndpointConfigModal.vue?vue&type=script&lang=js"
export * from "./EndpointConfigModal.vue?vue&type=script&lang=js"
import style0 from "./EndpointConfigModal.vue?vue&type=style&index=0&id=a1c81b8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c81b8e",
  null
  
)

export default component.exports